import React from "react";


export default function WeNeverUse() {
  const ingredients = [
    "Maida",
    "White Sugar",
    "Compound Chocolate",
    "Refined Oil",
    "Fondants/Colourful Sprinkles",
    "Synthetic Food Colors",
    "Premixes",
    "Contains Preservatives",
    "Egg",
  ];

  return (
    <div className="ms-lg-5">
    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
      <h5 className="neveruse-ing-content">
        ✘ We Never Use
      </h5>
      
    </div>

    <h3 style={{ color: "#dc3545", marginBottom: "10px"  }}>What Other Bakers Use</h3>

    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
      {ingredients.map((item, index) => (
        <li key={index} style={{ marginBottom: "6px", display: "flex", alignItems: "center" }}>
          <span style={{ color: "#dc3545", marginRight: "8px" }}>✘</span>
          {item}
        </li>
      ))}
    </ul>
  </div>
  );
}
